export default function LoadingScreen() {
  return <>Download Resources</>;
}
